import React from 'react';
import { Link } from 'react-router-dom';
import { formatEUR } from '../../utils/format';

const FeaturedProductsSection = ({ products }) => {
  if (products.length === 0) return null;

  const scrollContainer = React.useRef(null);

  const scroll = (direction) => {
    if (scrollContainer.current) {
      const scrollAmount = 250;
      scrollContainer.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="mb-8 md:mb-12">
      <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-8 text-gray-800">
        Unsere Highlights
      </h3>
      
      {/* Horizontal Scroll Container */}
      <div className="relative">
        {/* Scrollable Products - swipe to scroll on mobile */}
        <div 
          ref={scrollContainer}
          className="flex gap-4 overflow-x-auto pb-4 px-2 scroll-smooth"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}
        >
          {products.map((product, index) => {
            return (
              <Link 
                to={`/products/${product.id}`} 
                key={product.id}
                className="flex-shrink-0 w-40 sm:w-48 group bg-white shadow-sm hover:shadow-md transition-all border border-gray-100 overflow-hidden"
              >
                <div className="aspect-square overflow-hidden bg-gray-100">
                  {product.images && product.images.length > 0 && (
                    <img
                      src={product.images[0]}
                      alt={product.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 copy-protect-image"
                      draggable="false"
                    />
                  )}
                </div>
                
                <div className="p-3">
                  <h4 className="font-semibold text-sm mb-1 line-clamp-2 group-hover:text-[#3E2723] transition-colors">
                    {product.name}
                  </h4>
                  <p className="text-[#3E2723] font-bold text-base">
                    {formatEUR(product.price)}
                    {product.price_type === 'per_quantity' && product.price_quantity > 1 && (
                      <span className="text-xs font-normal text-gray-500 ml-1">
                        / {product.price_quantity} St.
                      </span>
                    )}
                  </p>
                  {product.color_variants && product.color_variants.length > 0 && (
                    <div className="flex gap-1 mt-2">
                      {product.color_variants.slice(0, 4).map((variant, idx) => (
                        <div
                          key={idx}
                          className="w-4 h-4 rounded-full border border-gray-300"
                          style={{ backgroundColor: variant.color_code }}
                          title={variant.color_name}
                        />
                      ))}
                      {product.color_variants.length > 4 && (
                        <span className="text-xs text-gray-500">+{product.color_variants.length - 4}</span>
                      )}
                    </div>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Scroll Indicator Dots */}
      <div className="flex justify-center gap-1 mt-4">
        <div className="w-8 h-1 bg-[#C4A084] rounded-full"></div>
        <div className="w-2 h-1 bg-gray-300 rounded-full"></div>
        <div className="w-2 h-1 bg-gray-300 rounded-full"></div>
      </div>
    </div>
  );
};

export default FeaturedProductsSection;
